{
  "columns": {
    "actions": "See the document",
    "amount": "Amount",
    "issueDate": "Issued At",
    "reference": "Reference"
  },
  "intlCurrency": "{{ value, currency(currency: EUR)}}",
  "title": "My Invoices"
}
